export const translation = {
  pt: {
    errorLabel: 'Erro',
    error: 'Ocorreu um erro',
    defaultError:
      'Ocorreu um erro com o upload dos seus arquivos, tente trocá-los',
    description:
      'Precisa de mais arquivos? Arraste seu arquivo para cá ou clique e selecione!',
    maxSize: 'Tamanho máximo',
    errorType: 'O tipo de arquivo enviado é inválido, envie apenas ',
    errorSize: 'O tamanho máximo permitido é de ',
    errorSmall: 'O arquivo é muito pequeno',
    errorQuantity: 'Muitos arquivos enviados, envie até',
    errorExists: 'Um dos arquivos enviados já foi utilizado',
    errorDoc: 'imagens ou documentos',
    errorImage: 'imagens',
    errorVideo: 'videos',
    errorSpreadsheet: 'arquivos .csv ou .xlsx',
    errorFiles: 'arquivo(s)'
  },
  en: {
    errorLabel: 'Error',
    error: 'An error occurred',
    defaultError:
      'An error occurred with uploading your files, please try changing them',
    description: 'Drag the file or click here to upload the file',
    maxSize: 'Maximum size',
    errorType: 'The file type sent is invalid, only send ',
    errorSize: 'The maximum allowed size is ',
    errorSmall: 'The file is too small',
    errorQuantity: 'Too many files sent, send up to',
    errorExists: 'One of the files sent has already been used',
    errorDoc: 'images or documents',
    errorImage: 'images',
    errorVideo: 'videos',
    errorSpreadsheet: 'files .csv or .xlsx',
    errorFiles: 'file(s)'
  },
  es: {
    errorLabel: 'Error',
    error: 'Se produjo un error',
    defaultError:
      'Se produjo un error al cargar tus archivos, por favor intenta cambiarlos',
    description: 'Arrastra el archivo o haz clic aquí para cargar el archivo',
    maxSize: 'Tamaño máximo',
    errorType: 'El tipo de archivo enviado no es válido, envía solo ',
    errorSize: 'El tamaño máximo permitido es de ',
    errorSmall: 'El archivo es demasiado pequeño',
    errorQuantity: 'Demasiados archivos enviados, envía hasta',
    errorExists: 'Uno de los archivos enviados ya ha sido utilizado',
    errorDoc: 'imágenes o documentos',
    errorImage: 'imágenes',
    errorVideo: 'videos',
    errorSpreadsheet: 'archivos .csv o .xlsx',
    errorFiles: 'archivo(s)'
  }
}
